<template>
  <div id="main_nav" :class="{ expanded: isActive, scroll: scrolled }">
    <div id="main_nav-wrapper">
      <div id="nav-bar">
        <router-link to="/" @click="isActive = !isActive">
          <img src="@/assets/logo.svg" alt="Clavo" >
        </router-link>
        <button class="hamburger hamburger--collapse" type="button" :class="{ isactive: isActive }" @click="isActive = !isActive">
          <span class="hamburger-box">
            <span class="hamburger-inner" />
          </span>
        </button>
      </div>
      <div id="menu">
        <ul>
          <li>
            <a href="/#see-who-is-working-when-and-where" @click="isActive = !isActive">{{ $t('menuWhyClavo') }}</a>
          </li>
          <li>
            <a href="/#features" @click="isActive = !isActive">{{ $t('menuFeatures') }}</a>
          </li>
          <li>
            <router-link to="/pricing" @click="isActive = !isActive">{{ $t('menuPricing') }}</router-link>
          </li>
          <li>
            <router-link to="/how-it-works" @click="isActive = !isActive">
              {{ $t('menuHowItWorks') }}
            </router-link>
          </li>
        </ul>
        <div v-if="loggedIn" class="menu-btns">
          <a href="https://go.clavo.app" class="button primary">{{ $t('goToYourAccountButton') }}</a>
        </div>
        <div v-else class="menu-btns">
          <!--a :href="getUrl('login', 'main')" class="button secondary">{{ $t('signInButton') }}</a-->
          <a :href="getUrl('register', 'main')" class="button">{{ $t('tryItFreeButton') }}</a>
        </div>
        <!-- <p>👋 &nbsp;Help us create a product tailored to your needs:</p>
        <a href="https://forms.gle/ihhTPJGP713KcLtr6" class="button secondary" target=_blank>
          Share Your Feedback
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
import BaseComponent from '@/components/BaseComponent'

export default {
  name: 'MainNavigation',
  mixins: [BaseComponent],
  props: {},
  data() {
    return {
      isActive: false,
      scrolled: false,
      loggedIn: false,
    }
  },
  created() {
    this.loggedIn = window.localStorage.getItem('loggedIn') === 'yes'
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 0
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/hamburgers/hamburgers.scss';

#main_nav {
  background-color: white;
  border-bottom: 1px solid #fff;
  position: fixed;
  z-index: 9999;
  width: 100%;
  top: 0;
  transition: border-bottom-color 0.3s ease-in;
  &.scroll {
    // box-shadow: 1px 2px 18px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid #e2e6e9;
  }

  #main_nav-wrapper {
    max-width: $maxWidth + 480px;
    margin: 0 auto;
    @include respond-above(md) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-content: center;
    }
  }
  #nav-bar {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    button {
      min-width: auto;
      &:focus,
      &:hover {
        outline: none;
        box-shadow: none;
      }
      @include respond-above(md) {
        display: none;
      }
    }

    a {
      margin-left: 20px;
      display: flex;
      align-content: center;
      align-items: center;
    }

    @include respond-above(md) {
      height: 84px;
      // width: 200px;
    }
  }

  #menu {
    text-align: center;
    padding: 0px var(--gutter);
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;

    @include respond-above(md) {
      max-height: none;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }

    ul {
      margin-top: 20px;
      li {
        font-family: $bold;
        font-size: 20px;
        line-height: 54px;
        a {
          color: $black;
          transition: all 0.1s ease-out;
          &:hover {
            color: $blue;
            text-decoration: none;
          }
        }
      }

      @include respond-above(md) {
        margin-top: 0;
        display: flex;
        flex-direction: row;
        li {
          font-family: $semibold;
          font-size: 16px;
          line-height: 24px;
          margin-right: 40px;
        }
      }
    }
    button,
    .button {
      margin-top: 24px;
      margin-bottom: 30px;
      width: 100%;
      display: block;
      @include respond-above(md) {
        width: auto;
        min-width: auto;
        margin: 0;
        margin-right: 20px;
        padding: 8px 26px;
        &.secondary {
          padding: 8px 18px;
        }
      }
    }
    .menu-btns {
      @include respond-above(md) {
        display: flex;
      }
    }
    p {
      font-family: $bold;
      font-size: 16px;
      line-height: 30px;
      color: $black;
      margin: 30px 20px;

      @include respond-above(md) {
        margin: 0 20px;
      }
    }
  }

  &.expanded {
    border-bottom: 1px solid #e2e6e9;
    @include respond-above(md) {
      &:not(.scroll) {
        border-bottom-color: white;
      }
    }
    #menu {
      max-height: 600px;
      opacity: 1;
      transition: max-height 0.15s ease-out;
    }
  }
}
</style>
